import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { CheckCircle2, Circle, Loader2 } from 'lucide-react';
const STAGES = [
    { label: 'Analyzing interview requirements', duration: 1100 },
    { label: 'Identifying key competencies', duration: 1400 },
    { label: 'Creating relevant evaluation criteria', duration: 1600 },
    { label: 'Preparing your candidate assessment', duration: 1200 },
];
/**
 * Phased "what's happening" loader for qualifying-criteria generation —
 * mirrors ObjectiveProgressLoader's staged feel without a numeric progress
 * bar, since the backend does not report incremental progress for this call.
 */
export const CriteriaProgressLoader = ({ compact = false } = {}) => {
    var _a;
    const [stageIndex, setStageIndex] = useState(0);
    useEffect(() => {
        if (stageIndex >= STAGES.length - 1)
            return;
        const timer = setTimeout(() => setStageIndex((i) => i + 1), STAGES[stageIndex].duration);
        return () => clearTimeout(timer);
    }, [stageIndex]);
    if (compact) {
        return (_jsxs("div", { className: 'flex w-[220px] flex-col gap-1', children: [_jsx("div", { className: 'h-1.5 w-full overflow-hidden rounded-full bg-dash-active', children: _jsx("div", { className: 'h-full rounded-full bg-dash-accent transition-all duration-500', style: { width: `${((stageIndex + 1) / STAGES.length) * 100}%` } }) }), _jsx("p", { className: 'truncate text-xs text-dash-muted', children: (_a = STAGES[stageIndex]) === null || _a === void 0 ? void 0 : _a.label })] }));
    }
    return (_jsxs("div", { className: 'flex w-[300px] flex-col space-y-3', children: [STAGES.map((stage, index) => {
                const isDone = index < stageIndex;
                const isActive = index === stageIndex;
                return (_jsxs("div", { className: 'flex items-center gap-2.5', children: [isDone ? (_jsx(CheckCircle2, { className: 'h-4 w-4 flex-shrink-0 text-dash-accent' })) : isActive ? (_jsx(Loader2, { className: 'h-4 w-4 flex-shrink-0 animate-spin text-dash-accent' })) : (_jsx(Circle, { className: 'h-4 w-4 flex-shrink-0 text-dash-border' })), _jsx("span", { className: `text-sm transition-colors ${isDone
                                ? 'text-dash-text2'
                                : isActive
                                    ? 'font-medium text-dash-text'
                                    : 'text-dash-muted'}`, children: stage.label })] }, stage.label));
            }), _jsxs("div", { className: 'flex items-center justify-center gap-1 pt-1', children: [_jsx("span", { className: 'h-1.5 w-1.5 animate-bounce rounded-full bg-dash-accent [animation-delay:-0.3s]' }), _jsx("span", { className: 'h-1.5 w-1.5 animate-bounce rounded-full bg-dash-accent [animation-delay:-0.15s]' }), _jsx("span", { className: 'h-1.5 w-1.5 animate-bounce rounded-full bg-dash-accent' })] }), _jsx("p", { className: 'text-center text-xs text-dash-muted', children: "This usually takes a few moments" })] }));
};
